import Reveal from "@/components/Reveal";

const services = [
  {
    tag: "Servizio Catering",
    title: "Cucina espressa",
    text: "Dalla scelta di ingredienti sempre freschi alla generosità dei nostri piatti: proponiamo una cucina semplice e gustosa, bella da vedere, buona da mangiare e capace di accontentare anche gli invitati più esigenti.",
    img: "/catering.webp",
    alt: "Finger food del nostro catering: cestini croccanti con condimenti freschi",
    testid: "service-catering",
  },
  {
    tag: "Allestimenti",
    title: "Arredi, mise en place e balloon design",
    text: "Dalla scelta dei colori alla disposizione degli spazi: curiamo ogni allestimento con la massima attenzione per creare un ambiente accogliente, elegante e pensato in ogni minimo particolare.",
    img: "/allestimenti.webp",
    alt: "Allestimento con balloon design e numero 18 luminoso per un diciottesimo",
    testid: "service-allestimenti",
  },
  {
    tag: "Fotografo Professionista",
    title: "Ogni istante, per sempre",
    text: "Emozioni spontanee, sorrisi veri e tutti i momenti più importanti: il nostro fotografo è un occhio attento che immortala la vostra storia con discrezione e professionalità.",
    img: "/fotografo.jpg",
    alt: "Il fotografo del Club mentre immortala la festa",
    aspect: "aspect-[3/4] max-w-md",
    testid: "service-fotografo",
  },
  {
    tag: "DJ e Animazione",
    title: "Si balla fino a tardi",
    text: "DJ set d'impatto, animazione coinvolgente e consolle accesa fino a tardi: il ritmo ideale per far divertire tutti dall'inizio alla fine.",
    img: "/dj-animazione.jpg",
    alt: "Ospiti che cantano e ballano durante il DJ set al Club",
    testid: "service-dj-animazione",
  },
];

export default function Servizi() {
  return (
    <section id="servizi" data-testid="servizi-section" className="bg-deepblue px-6 py-28 md:py-40 lg:px-10">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <p className="mb-6 flex items-center gap-4 text-xs font-medium uppercase tracking-[0.35em] text-dusty">
            <span className="h-px w-10 bg-dusty/70" /> Servizi
          </p>
          <h2 className="max-w-2xl font-serif text-4xl leading-tight tracking-tight text-linen sm:text-5xl md:text-6xl">
            Tutto quello che serve per la vostra <span className="italic text-dusty">festa</span>.
          </h2>
        </Reveal>

        <div className="mt-20 flex flex-col gap-24 md:mt-28">
          {services.map((s, i) => (
            <div key={s.tag} className="grid items-center gap-10 lg:grid-cols-2 lg:gap-20" data-testid={s.testid}>
              <Reveal delay={0.1} className={i % 2 === 1 ? "lg:order-2" : ""}>
                <div className={`group relative overflow-hidden ${s.aspect ?? "aspect-[4/3]"}`}>
                  <img
                    src={s.img}
                    alt={s.alt}
                    className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                </div>
              </Reveal>
              <Reveal delay={0.2} className={i % 2 === 1 ? "lg:order-1" : ""}>
                <div className={i % 2 === 1 ? "lg:pr-8" : "lg:pl-8"}>
                  <p className="flex items-center gap-4 text-xs font-medium uppercase tracking-[0.35em] text-dusty">
                    <span className="font-serif text-2xl normal-case italic tracking-normal text-sand">0{i + 1}</span> {s.tag}
                  </p>
                  <h3 className="mt-6 font-serif text-3xl leading-tight tracking-tight text-linen sm:text-4xl md:text-5xl">
                    {s.title}
                  </h3>
                  <p className="mt-6 max-w-lg text-base font-light leading-relaxed text-linen/60 md:text-lg">
                    {s.text}
                  </p>
                </div>
              </Reveal>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
